import moment from 'moment';

const transformMeterData = (data, facilityId, officeId = undefined) => {
  const {
    facilityTariff,
    roomTariff,
    dayReading,
    nightReading,
    generalReading,
    commissioningDate,
    verificationDate,
    ...otherData
  } = data;

  const transformedData = {
    ...otherData,
    type: {
      id: data.type.key,
    },
    house: {
      id: facilityId,
    },
  };

  if (commissioningDate !== null) {
    transformedData.commissioningDate = moment(commissioningDate)
      .endOf('day')
      .toISOString();
  }

  if (verificationDate !== null) {
    transformedData.verificationDate = moment(verificationDate)
      .endOf('day')
      .toISOString();
  }

  if (officeId !== undefined) {
    transformedData.office = { id: officeId };
  }

  return transformedData;
};

export default transformMeterData;
